
































import { Component, Prop, Emit } from 'vue-property-decorator';
import Mixin from '@/mixin';
import VModalConfirmation from '@/components/popup/VModalConfirmation.vue';
import VMenuButton from '@/components/menu/VMenuButton.vue';
import VBackButton from '@/components/items/VBackButton.vue';
import popupModule from '@/store/modules/common/popup.module';
import popup from '@/data/popup.json';
import jwtService from '@/services/common/jwt.service';

@Component({
  name: 'VNavigator',
  components: {
    VBackButton,
    VMenuButton,
    VModalConfirmation
  }
})
export default class Navigator extends Mixin {
  @Prop() title!: string;
  @Prop() showRightMenu!: boolean;
  @Prop() showTranslation?: boolean;
  @Prop({ default: true }) backButton?: boolean;
  @Prop() rightCommand?: string;

  get language(): string {
    if (this.$i18n.locale === 'vi') {
      return 'en';
    }
    return 'vn';
  }

  public async showConfirm() {
    await Promise.all([
      popupModule.initPopup(popup.goHome),
      popupModule.setShowPopup(true)
    ]);
  }

  public toggleTranslation(): void {
    this.$i18n.locale = this.language == 'en' ? 'en' : 'vi';
    jwtService.saveLanguage(this.$i18n.locale);
  }

  @Emit()
  public onCommandClick(command: string) {}
}
